import { location } from "../../data/Fleet/Location";
import { TrailerType } from "../../data/Fleet/TrailerType";

export const trailerFieldConfiguration = [
  {
    name: "unitNumber",
    label: "Unit Number",
    type: "text",
    validation: {
      required: "Unit Number is required",
      maxLength: {
        value: 20,
        message: "Unit Number must not exceed 20 characters",
      },
    },
  },
  {
    name: "make",
    label: "Make",
    type: "text",
    validation: {
      required: "Make is required",
      maxLength: { value: 15, message: "Make must not exceed 15 characters" },
    },
  },
  {
    name: "model",
    label: "Model",
    type: "text",
    validation: {
      required: "Model is required",
      maxLength: { value: 15, message: "Model must not exceed 15 characters" },
    },
  },
  {
    name: "year",
    label: "Year",
    type: "number",
    validation: {
      required: "Year is required",
      min: { value: 2000, message: "Year must be later than 2000" },
      max: {
        value: new Date().getFullYear() + 1,
        message: "Year must not be in the future",
      },
    },
  },
  {
    name: "VIN",
    label: "VIN",
    type: "text",
    validation: {
      required: "VIN is required",
      minLength: { value: 17, message: "VIN must be 17 characters" },
      maxLength: { value: 17, message: "VIN must be 17 characters" },
    },
  },
  {
    name: "licensePlate",
    label: "License Plate",
    type: "text",
    validation: {
      required: "License Plate is required",
      maxLength: {
        value: 10,
        message: "License Plate must not exceed 10 characters",
      },
    },
  },
  {
    name: "state",
    label: "State",
    type: "select",
    options: location,
    validation: {
      required: "State is required",
    },
  },
  {
    name: "tireSize",
    label: "Trailer Tire Size",
    type: "text",
    validation: {
      required: "Tire Size is required",
      maxLength: {
        value: 5,
        message: "Tire Size must not exceed 5 characters",
      },
      pattern: {
        value: /^[0-9]*\.?[0-9]*$/,
        message: "Tire Size must be a number",
      },
    },
  },
  {
    name: "companyOwnerId",
    label: "Company Owner",
    type: "combo",
    dataKey: "ownerCompanies",
    validation: {
      required: "Company Owner is required",
    },
  },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      { label: "Repair", value: "REPAIR" },
      { label: "Available", value: "AVAILABLE" },
      { label: "Sold", value: "SOLD" },
      { label: "Leased", value: "LEASED" },
      { label: "Rented", value: "RENTED" },
      { label: "Personal", value: "PERSONAL" },
      { label: "Placeholder", value: "PLACEHOLDER" },
      { label: "For sale", value: "FOR-SALE" },
    ],
    validation: {
      required: "Status is required",
    },
  },
  {
    name: "trailerType",
    label: "Trailer Type",
    type: "select",
    options: TrailerType,
    validation: {
      required: "Trailer Type is required",
    },
  },
  {
    name: "length",
    label: "Length",
    type: "text",
    validation: {
      required: "Length is required",
      pattern: { value: /^\d+(\.\d+)?$/, message: "Length must be a number" },
    },
  },
  {
    name: "loanId",
    label: "Loan",
    type: "combo",
    dataKey: "loansData",
  },
];

export const trailerInitialValues = {
  unitNumber: "",
  make: "",
  model: "",
  year: "",
  VIN: "",
  licensePlate: "",
  state: "",
  tireSize: "",
  companyOwnerId: "",
  transactionType: "",
  trailerType: "",
  length: "",
  loanId: "",
};
